import {
    Box,
    VStack,
} from '@chakra-ui/react';
import { QuotesNotSubmitted } from '../index';
import { OrderDrawerResponse } from '../../hooks/useGetOrderDrawer';
import EmsExportHistoryTimeline from '../order/EmsExportHistoryTimeline';
import { useNavigate } from 'react-router-dom';

interface EmsTabPanelProps {
    data: NonNullable<OrderDrawerResponse['ems']>;
    orderId: string;
    onClose: () => void;
}

const EmsTabPanel = ({
    data,
    orderId,
    onClose,
}: EmsTabPanelProps) => {
    const navigate = useNavigate();

    return (
        <VStack align="stretch">
            {data.needsQuotes ? (
                <Box mb={2}>
                    <QuotesNotSubmitted
                        onClick={() => {
                            navigate(`/order/${orderId}`, { state: { initialStatus: 'newParts' } });
                            onClose();
                        }}
                    />
                </Box>
            ) : null}

            {data.pushes.length > 0 && (
                <EmsExportHistoryTimeline pushes={data.pushes} />
            )}
        </VStack>
    );
};

export default EmsTabPanel;
